import { apiErrorCode } from "../../lib/apiErrors";
import { TAGS_MAX_COUNT, TAG_MAX_LENGTH } from "../hqCustomerRules";

export const EMAIL_EXISTS_CODE = "customer_email_exists";
export const LINKED_TO_PRACTICE_CODE = "customer_linked_to_practice";
export const INVALID_TAGS_CODE = "invalid_tags";
export const TAGS_CONTENDED_CODE = "customer_tags_contended";
export const NO_RECIPIENT_CODE = "customer_has_no_email";
export const REQUEST_REUSED_CODE = "communication_request_reused";

// `422 {code: "invalid_tags", reason}` (contract §2.3) -> the sentence for that reason.
const TAG_REASON_KEYS = {
  too_many: "hc.tagTooMany",
  empty: "hc.tagEmpty",
  invisible: "hc.tagInvisible",
  too_long: "hc.tagTooLong",
  control_chars: "hc.tagControl",
  not_text: "hc.tagNotText",
};

/** The id of the client a `customer_email_exists` refusal points at, `""` for any other failure. */
export const duplicateEmailCustomerId = (e) => {
  if (apiErrorCode(e) !== EMAIL_EXISTS_CODE) return "";
  const detail = e?.response?.data?.detail;
  return typeof detail?.customer_id === "string" ? detail.customer_id : "";
};

/**
 * The sentence for a failed HQ customer request, in the operator's language. The refusals this
 * screen knows (no permission, vanished client, duplicate email, practice-linked delete, refused
 * tags, a contended tag edit, an email with nobody to send it to, a reused request key, the
 * per-client and per-IP email caps) get their own wording. Anything else — an English server string, an
 * unknown structured detail, a validation list — is `fallbackKey`'s sentence: no server text and
 * no raw `detail` ever reaches the screen. `t` is the `superadmin` translator.
 */
export function hqCustomerErrorMessage(e, t, fallbackKey = "hc.saveFailed") {
  if (e?.response?.status === 403) return t("hc.noPermission");
  const code = apiErrorCode(e);
  if (code === EMAIL_EXISTS_CODE) return t("hc.emailExists");
  if (code === LINKED_TO_PRACTICE_CODE) return t("hc.deleteLinked");
  if (code === TAGS_CONTENDED_CODE) return t("hc.tagsContended");
  if (code === NO_RECIPIENT_CODE) return t("hc.comm.noRecipient");
  if (code === REQUEST_REUSED_CODE) return t("hc.comm.requestReused");
  // Both bounds (the per-client hourly cap answers a coded 429, the per-IP floor a bare one) read the same.
  if (e?.response?.status === 429) return t("hc.comm.rateLimited");
  if (code === INVALID_TAGS_CODE) {
    const detail = e?.response?.data?.detail;
    const reason = typeof detail?.reason === "string" ? detail.reason : "";
    if (TAG_REASON_KEYS[reason]) return t(TAG_REASON_KEYS[reason], { max: reason === "too_many" ? TAGS_MAX_COUNT : TAG_MAX_LENGTH });
  }
  if (e?.response?.status === 404) return t("hc.notFound");
  return t(fallbackKey);
}
